import { SocialChatJsonMessage } from '@missionlabs/smartagent-service-chat/dist/types/socialChatJsonMessage'
import { ISocialChatMessage } from 'store/chat/chat.state'

export const sortMessagesWithOriginalTimestamp = (messages: ISocialChatMessage[]) => {
    messages.sort((a, b) => {
        if (
            !(a.content as SocialChatJsonMessage)?.originalTimestamp ||
            !(b.content as SocialChatJsonMessage)?.originalTimestamp
        ) {
            return 0
        }

        return (
            (a.content as SocialChatJsonMessage).originalTimestamp! -
            (b.content as SocialChatJsonMessage).originalTimestamp!
        )
    })
}

export const removeDuplicateParticipantJoinedMessages = (messages: ISocialChatMessage[]) => {
    const participantJoinedEvent = 'application/vnd.amazonaws.connect.event.participant.joined'
    return messages.reduce((messages: ISocialChatMessage[], currentMessage: ISocialChatMessage) => {
        if (
            !messages.find(
                (message) =>
                    message.AbsoluteTime === currentMessage.AbsoluteTime &&
                    message.ContentType === participantJoinedEvent,
            )
        ) {
            messages.push(currentMessage)
        }
        return messages
    }, [])
}
